import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { inToolboxItems } from '../../canvas/tooling/ToolboxController';
import { inTool } from '../../canvas/tooling/ToolManager';
import { Package, PackageHost } from '../../Container';
import { clearReactions } from './ReactionCommands';
import { reactionTool } from './ReactionTool';
import { reactionToolboxItem } from './ReactionToolboxItem';

// const inStandardToast: Connector = r => {
//     r.call(ToastRegister)
//         .add(defineToast('test', 'positive', 'Testing one two three?'))
//         .add(defineToast('ptpt:join', 'info', '{sender.name} has joined the session.'))
//         .add(defineToast('ptpt:mute', 'info', '{sender.name} has been muted for spamming.'));
// };

export class ReactionPackage implements Package {

    public install = (host: PackageHost) => host
        .plug(inCommands(clearReactions))
        .plug(inTool(reactionTool))
        .plug(inToolboxItems(reactionToolboxItem))
        ;
}
